import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import Contests from "../Components/Contests/Contests";
import Context from "../context/Context";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import "./HomePage.css";
import goviralLogo23 from "../assests/goviralLogo23.svg";
import hoeLogo from "../assests/hoeLogo.png";
import moment from "moment";
import * as _ from "lodash";
import loadingAnimation from "../assests/loading.json";
import styles from "./styles/HomePage.module.css";
import arrow from "../assests/arrow.svg";
import Bluearrow from "../assests/blueArrow.png";
import Star from "../assests/Star.png";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import Organiser from "../Components/Organiser/Organiser";
import Lottie from "react-lottie-player";
import ContestsTemp from "../Components/Contests/ContestsTemp";
import { includes } from "lodash";
import OtherContest from "../Components/Contests/OtherContest";
import underReviewImage from "../assests/underReview.svg";
import ContestsForFestval from "../Components/Contests/ContestsForFestval";
import Banner from "../Components/Banner";
import Judges from "./Judges";
import Promoters from "./Promoters";
import Sponsers from "./Sponsers";
import AbsolutePage from "./AbsolutePage";
import ContestCardView from "../Components/Contests/ContestCardView";
import NavigationHeader from "../Components/NavigationHeader/NavigationHeader";
import FloatingWidgets from "../Components/FloatingWidgets/FloatingWidgets";
import videoContestIcon from "../assests/videoContestIcon.svg";
import photoContestIcon from "../assests/photoContestIcon.svg";
import JudgesPopup from "../Components/JudgesPopup/JudgesPopup";
import SponsorPopup from "../Components/SponsorPopup/SponsorPopup";
import ContestCardCarousel from "../Components/ContestCardCarousel/ContestCardCarousel";
import PromoterPopup from "../Components/PromoterPopup/PromoterPopup";
import WinnerAnouncer from "./WinnerAnouncer";
import WinnerAnnoncerPopup from "../Components/WinnerAnnoncerPopup/WinnerAnnoncerPopup";
import Organizer from "./Organizer";
import OrganizerPopup from "../Components/OrganizerPopup/OrganizerPopup";
import { useUserAuth } from "../context/UserAuthContext";
import SpecialGuests from "./SpecialGuests";
import GuestPopup from "../Components/GuestPopup/GuestPopup";
import axios from "axios";
import DetailPopup from "../Components/DetailPopup/DetailPopup";
import CampaignNotPublished from "../Components/CampaignNotPublished/CampaignNotPublished";
import Coupons from "../Components/Coupons/Coupons";
import Ads from "../Components/Ads/Ads";
import ServiceForm from "../Components/ServiceForm/ServiceForm";
import SupportedBy from "./SupportedBy";
import ProgressPopup from "../Components/ProgressPopup/ProgressPopup";
import progressStar from "../assests/progressStar.svg";

function HomePage() {
  const navigate = useNavigate();
  const {
    details,
    underReview,
    filterState,
    setFilterState,
    loadHomePageDetails,
    campaignMetaData,
    showTHeBlackScreen,
    setshowTHeBlackScreen,
    blackScreen,
    setBlackScreen,
    preview,
    scrollDownState,
    setScrollDownState,
    getParticipantCounter,
    pageLoading,
    coupons,
    setCoupons,
    ads,
    setAds,
    userIdToken,
    buildType,
  } = useContext(Context);
  // console.log(details);
  const { searchParams, currentUser } = useUserAuth();
  const [showDetails, setShowDetails] = useState(false);
  const [showFullText, setShowFullText] = useState(false);
  const [filteredContest, setFilteredContest] = useState([]);
  const [judgesPopup, setJudgesPopup] = useState(false);
  const [judgeDetails, setJudgeDetails] = useState({});
  const [winnerAnouncementPopup, setWinnerAnouncementPopup] = useState(false);
  const [winnerAnouncementDetails, setWinnerAnouncementDetails] = useState({});
  const [sponsorPopup, setSponsorPopup] = useState(false);
  const [sponsorDetails, setSponsorDetails] = useState({});
  const [organizerPopup, setOrganizerPopup] = useState(false);
  const [organizerDetails, setOrganizerDetails] = useState({});
  const [promoterPopup, setPromoterPopup] = useState(false);
  const [promoterDetails, setPromoterDetails] = useState({});
  const [guestPopup, setGuestPopup] = useState(false);
  const [guestDetails, setGuestDetails] = useState({});
  const [inflencerDetails, setInflencerDetails] = useState({});
  const [service, setService] = useState();
  const [showProgress, setShowProgress] = useState(false);
  const [progressData, setProgressData] = useState({});
  const [serviceForm, setServiceForm] = useState(false);
  const [detailsPopup, setDetailsPopup] = useState(false);
  let infId = searchParams.get("presentedBy") || searchParams.get("p");
  const token = userIdToken || currentUser?.accessToken;
  const location = useLocation();
  const isJudgE = "theBlurBg";
  useEffect(() => {
    filterContest(filterState);
  }, [filterState, details]);
  let fullcontestList = details && details?.contests;
  const viewMore = () => {
    setShowFullText((prev) => !prev);
  };
  useEffect(() => {
    loadHomePageDetails(
      campaignMetaData?.organizerName,
      campaignMetaData?.campaignName
    );
    // eslint-disable-next-line
  }, [campaignMetaData?.organizerName]);
  useEffect(() => {
    if (!_.isEmpty(details)) {
      loadAdsDetails(details?.orgId, details?.campaignId);
    }
  }, [details]);
  useEffect(() => {
    if (!_.isEmpty(details) && infId) {
      loadInfluencerAdsDetails(details?.orgId, details?.promotionId, infId);
    }
  }, [details]);
  const loadInfluencerAdsDetails = async (orgId, promotionId, infId) => {
    try {
      const data = await axios.get(
        `${process.env.REACT_APP_PROMOTION_ENTRY_DETAILS_JSON}/${orgId}/${promotionId}/${infId}/influencerDetails.json`
      );
      setInflencerDetails(data?.data);
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    if (!_.isEmpty(details)) {
      if (details?.closedCampaign) {
        if (!currentUser) {
          handleSignup();
          return;
        }
      }
      if (details?.contests && details.contests.length <= 1) {
        navigate({
          pathname: `/${campaignMetaData?.organizerName}/${
            campaignMetaData?.campaignName
          }/${details?.contests && details.contests[0]?.contestUniqueText}`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        });
      }
    }
  }, [details]);

  const handleSignup = () => {
    navigate(
      {
        pathname: `/${campaignMetaData?.organizerName}/${campaignMetaData?.campaignName}/signup`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      },
      {
        state: {
          previousLocation: location?.pathname,
        },
      }
    );
  };
  useEffect(() => {
    if (!_.isEmpty(details)) {
      getParticipantCounter(details?.orgId, details?.campaignId);
    }
  }, [details]);
  const scrollDown = () => {
    window.scrollTo({
      top: 400,
      behavior: "smooth",
    });
  };
  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    if (!_.isEmpty(details) && scrollDownState) {
      scrollDown();
      setScrollDownState(false);
      setTimeout(() => {
        scrollUp();
      }, "1800");
    }
  }, [details]);
  const element = document.querySelector(".scroll");

  if (element) {
    let scroll;
    element.addEventListener("wheel", (event) => {
      event.preventDefault();
      // console.log(event.deltaY);
      if (scroll == element.scrollLeft) {
        element.removeEventListener("wheel", (event) => {
          event.preventDefault();
        });
      }
      element.scrollLeft += event.deltaY;
      scroll = element.scrollLeft;
    });
  }
  const filterContest = (filterValue) => {
    setFilterState(filterValue);
    let filter = [];
    if (filterValue == "ALL") {
      filter = details?.contests;
    } else if (filterValue == "CLOSED") {
      filter =
        details &&
        details.contests &&
        details.contests?.filter((el) => {
          return el?.contestStatus?.includes(filterValue);
        });
    } else {
      filter =
        details &&
        details.contests &&
        details.contests?.filter((el) => {
          return (
            el?.groupId?.includes(filterValue) &&
            !el?.contestStatus?.includes("CLOSED")
          );
        });
    }

    setFilteredContest(filter);
  };
  const filterContestForListView = (filterValue, contests) => {
    let filter = [];
    if (filterValue == "ALL") {
      filter = contests;
    } else if (filterValue == "CLOSED") {
      filter = contests?.filter((el) => {
        return el?.contestStatus?.includes(filterValue);
      });
    } else {
      filter = contests?.filter((el) => {
        return el?.groupId?.includes(filterValue);
        // &&
        // !el?.contestStatus?.includes("CLOSED")
      });
    }
    return filter;
  };
  const getCampaignProgress = async (orgId, campaignId) => {
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_PARTICIPANT_PROGRESS}/${orgId}/${campaignId}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    let result = await axios(config);
    setProgressData(result?.data?.data);
  };
  // const sliderRef = useRef(null);
  // const [isDragging, setIsDragging] = useState(false);
  // const [startX, setStartX] = useState(0);
  // const [scrollLeft, setScrollLeft] = useState(0);

  // const handleMouseDown = (event) => {
  //   setIsDragging(true);
  //   setStartX(event.clientX - sliderRef.current.offsetLeft);
  //   setScrollLeft(sliderRef.current.scrollLeft);
  // };

  // const handleMouseMove = (event) => {
  //   if (!isDragging) return;
  //   const x = event.clientX - sliderRef.current.offsetLeft;
  //   const scroll = x - startX;
  //   sliderRef.current.scrollLeft = scrollLeft - scroll;
  // };

  // const handleMouseUp = () => {
  //   setIsDragging(false);
  // };

  // const sliderRefVideo = useRef(null);
  // const [isDraggingVideo, setIsDraggingVideo] = useState(false);
  // const [startXVideo, setStartXVideo] = useState(0);
  // const [scrollLeftVideo, setScrollLeftVideo] = useState(0);

  // const handleMouseDownVideo = (event) => {
  //   setIsDraggingVideo(true);
  //   setStartXVideo(event.clientX - sliderRefVideo.current.offsetLeft);
  //   setScrollLeftVideo(sliderRefVideo.current.scrollLeft);
  // };

  // const handleMouseMoveVideo = (event) => {
  //   if (!isDraggingVideo) return;
  //   const x = event.clientX - sliderRefVideo.current.offsetLeft;
  //   const scroll = x - startXVideo;
  //   sliderRefVideo.current.scrollLeft = scrollLeftVideo - scroll;
  // };

  // const handleMouseUpVideo = () => {
  //   setIsDraggingVideo(false);
  // };
  const profileHelpNavigate = () => {
    if (preview) {
      navigate({
        pathname: `/profile/help`,
        search: "?preview=true",
      });
    } else {
      navigate({
        pathname: `/profile/help`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    }
  };
  const filteredVideoArray = filterContestForListView(
    "ALL",
    details?.contests
  )?.filter((obj) => {
    return obj.fileType?.startsWith("video");
  });
  const filteredImageArray = filterContestForListView(
    "ALL",
    details?.contests
  )?.filter((obj) => {
    return obj.fileType?.startsWith("image");
  });

  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const contentOffset =
        document.getElementById("content").getBoundingClientRect().top - 50;
      setIsFixed(contentOffset < 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const plainCampaignDesciption = details?.description?.replace(/<[^>]+>/g, "");
  const truncatedText =
    plainCampaignDesciption?.slice(0, 70) +
    (plainCampaignDesciption?.length > 70 ? "..." : "");

  const startDate = new Date(details?.startDate);
  const formattedStartDate = `${startDate.toLocaleString("default", {
    month: "short",
  })} ${startDate.getUTCDate()}  `;
  const endDate = new Date(details?.endDate);
  const formattedEndDate = `${endDate.toLocaleString("default", {
    month: "short",
  })} ${endDate.getUTCDate()} ${endDate.getUTCFullYear()}`;

  var filterChips = inflencerDetails?.filterChips || details?.filterChips;
  const loadAdsDetails = async (orgId, campaignId) => {
    try {
      const data = await axios.get(
        `https://storage.googleapis.com/goviral-share/${orgId}/${campaignId}/ads.json`
      );
      setAds(data.data?.ads?.ads);
      setCoupons(data.data?.discountCoupons);
    } catch (error) {
      console.log(error.message);
      //navigate("/error")
    }
  };
  const handleClickCounterCampaign = async (
    brandId,
    id,
    adsName,
    brandName,
    type,
    catType
  ) => {
    let config = {
      method: "post",
      url: `${process.env.REACT_APP_HIT_COUNTER_CAMPAIGN}/${details?.campaignId}/${details?.orgId}/${brandId}/${id}?type=${type}&catType=${catType}`,
      data: {
        name: adsName,
        brandName: brandName,
        token: token ? token : "null",
        infId: parseInt(infId),
      },
    };

    const response1 = await axios(config);
  };
  return (
    <>
      <div className="widthController">
        {_.isEmpty(details) ? (
          <>
            {pageLoading ? (
              <div className="w-[100%] h-[100vh] flex items-center justify-center">
                <Lottie
                  loop
                  animationData={loadingAnimation}
                  play
                  style={{ width: 173, height: 173 }}
                />
              </div>
            ) : (
              underReview && <CampaignNotPublished />
            )}
          </>
        ) : (
          <div>
            <FloatingWidgets
              page="campaign"
              prize={details?.priceDescription}
              endTime={details?.endDate}
              color={details?.btnColor}
              bgColor={details?.bgColor}
            />
            {/* <Banner/> */}
            {!showDetails && (
              <div className="homepage ">
                <NavigationHeader isFixed={isFixed} type="campaign" />
                <Header
                  details={details}
                  type="campaign"
                  coverImage={details?.coverImage}
                  isFixed={isFixed}
                  headingStyle={details?.campaignNameStyle}
                  heading={details?.campaignName}
                />
                <div className="w-[100%]">
                  <div
                    className="theBlurBg mt-[370px] rounded-t-[24px]  w-[100%] "
                    id="content"
                  >
                    <div className="z-[1] relative  borderRad  px-[20px]">
                      <div className="w-[100%] text-center pb-[20px] pt-[35px]">
                        <p
                          className="text-large-medium mb-[11px]"
                          style={{ color: details?.btnColor }}
                        >
                          About Campaign
                        </p>
                        <p
                          className="text-regular mb-[11px]"
                          style={{ color: details?.btnColor }}
                        >
                          Submission Period : {formattedStartDate}-{" "}
                          {formattedEndDate}
                        </p>
                        <div
                          className="text-small text-[#CDCDCD] cursor-pointer"
                          onClick={viewMore}
                        >
                          {showFullText ? (
                            <>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: `${details?.description}`,
                                }}
                                className="flex flex-col gap-[12px]"
                              />
                              {details && details.description?.length > 70 && (
                                <span className="text-[#0F6ABE] whitespace-nowrap">
                                  {" "}
                                  Read Less
                                </span>
                              )}
                            </>
                          ) : (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: `${truncatedText}`,
                              }}
                            />
                          )}
                          {!showFullText &&
                            details?.description?.length > 70 && (
                              <>
                                <span className="text-[#0F6ABE] whitespace-nowrap">
                                  {" "}
                                  Read More
                                </span>
                              </>
                            )}
                        </div>
                      </div>
                      <div className="seperator" />
                      {/* <div className="flex gap-[7px] items-center py-[10px] w-full justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="27"
                          height="27"
                          viewBox="0 0 27 27"
                          fill="none"
                        >
                          <path
                            d="M16.0243 1.53369C18.1562 9.46192 17.1629 13.6471 13.0443 14.0894C5.80245 14.0894 3.51605 18.525 4.47675 20.7486C5.43745 22.9722 8.45443 24.7202 10.9255 25.1431C13.3966 25.566 17.4015 25.5992 22.4018 20.7486C27.4021 15.8979 23.8502 8.06987 22.4018 6.01706C21.4362 4.64851 19.3103 3.15406 16.0243 1.53369Z"
                            fill="#D8D8D8"
                          />
                          <mask
                            id="mask0_3750_7769"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x="4"
                            y="1"
                            width="21"
                            height="25"
                          >
                            <path
                              d="M16.0274 1.53369C18.1594 9.46192 17.166 13.6471 13.0475 14.0894C5.80562 14.0894 3.51922 18.525 4.47992 20.7486C5.44062 22.9722 8.45761 24.7202 10.9287 25.1431C13.3998 25.566 17.4047 25.5992 22.405 20.7486C27.4053 15.8979 23.8534 8.06987 22.405 6.01706C21.4394 4.64851 19.3135 3.15406 16.0274 1.53369Z"
                              fill="#FFA0A0"
                            />
                          </mask>
                          <g mask="url(#mask0_3750_7769)">
                            <path
                              d="M27.2734 -1.18555H-1.18115V27.269H27.2734V-1.18555Z"
                              fill={details?.btnColor}
                            />
                          </g>
                          <path
                            d="M13.0417 26.0833C5.83895 26.0833 0 20.2444 0 13.0417C0 5.83895 5.83895 0 13.0417 0C20.2444 0 26.0833 5.83895 26.0833 13.0417C26.0833 20.2444 20.2444 26.0833 13.0417 26.0833ZM13.0417 23.9967C19.092 23.9967 23.9967 19.092 23.9967 13.0417C23.9967 6.99139 19.092 2.08667 13.0417 2.08667C6.99139 2.08667 2.08667 6.99139 2.08667 13.0417C2.08667 19.092 6.99139 23.9967 13.0417 23.9967ZM11.8561 11.8561C11.8561 11.2013 12.3869 10.6705 13.0417 10.6705C13.6965 10.6705 14.2273 11.2013 14.2273 11.8561V17.7841C14.2273 18.4389 13.6965 18.9697 13.0417 18.9697C12.3869 18.9697 11.8561 18.4389 11.8561 17.7841V11.8561ZM13.0417 9.48485C12.3869 9.48485 11.8561 8.95404 11.8561 8.29925C11.8561 7.64445 12.3869 7.11364 13.0417 7.11364C13.6965 7.11364 14.2273 7.64445 14.2273 8.29925C14.2273 8.95404 13.6965 9.48485 13.0417 9.48485Z"
                            fill="black"
                          />
                          <mask
                            id="mask1_3750_7769"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="27"
                            height="27"
                          >
                            <path
                              d="M13.0417 26.0833C5.83895 26.0833 0 20.2444 0 13.0417C0 5.83895 5.83895 0 13.0417 0C20.2444 0 26.0833 5.83895 26.0833 13.0417C26.0833 20.2444 20.2444 26.0833 13.0417 26.0833ZM13.0417 23.9967C19.092 23.9967 23.9967 19.092 23.9967 13.0417C23.9967 6.99139 19.092 2.08667 13.0417 2.08667C6.99139 2.08667 2.08667 6.99139 2.08667 13.0417C2.08667 19.092 6.99139 23.9967 13.0417 23.9967ZM11.8561 11.8561C11.8561 11.2013 12.3869 10.6705 13.0417 10.6705C13.6965 10.6705 14.2273 11.2013 14.2273 11.8561V17.7841C14.2273 18.4389 13.6965 18.9697 13.0417 18.9697C12.3869 18.9697 11.8561 18.4389 11.8561 17.7841V11.8561ZM13.0417 9.48485C12.3869 9.48485 11.8561 8.95404 11.8561 8.29925C11.8561 7.64445 12.3869 7.11364 13.0417 7.11364C13.6965 7.11364 14.2273 7.64445 14.2273 8.29925C14.2273 8.95404 13.6965 9.48485 13.0417 9.48485Z"
                              fill="white"
                            />
                          </mask>
                          <g mask="url(#mask1_3750_7769)">
                            <path
                              d="M27.2693 -1.18555H-1.1853V27.269H27.2693V-1.18555Z"
                              fill="white"
                            />
                          </g>
                        </svg>
                        <p
                          className="text-regular-medium"
                          style={{ fontFamily: "Radio Canada" }}
                        >
                          For more details, click cards below
                        </p>
                      </div> */}
                      {details?.priceDescription && (
                        <div className="text-center px-[16px] py-[12px] w-[100%] px[27px] pt-[16px] pb-[24px]">
                          <div
                            className={styles.stars}
                            style={{ color: details?.contests[0]?.buttonColor }}
                          >
                            <span></span>
                            <span className={styles.middleStar}></span>
                            <span></span>
                          </div>
                          <p className="text-smallest mb-[12px] mt-[10px]">
                            CAMPAIGN PRIZE
                          </p>
                          <p
                            className="text-large-bold mb-[16px]"
                            style={{ color: details?.contests[0]?.buttonColor }}
                          >
                            {details?.priceDescription}
                          </p>
                          <p className="text-[#cdcdcd] text-smallest">
                            Participate in our thrilling online contest and
                            stand a chance to win amazing prizes for each
                            contest.
                          </p>
                        </div>
                      )}
                      <div className="seperator" />
                    </div>

                    <div className="items-center  z-[1] relative justify-center flex-col pt-[30px]  w-[100%]">
                      <div className="min-h-[100px] mb-[32px]">
                        {!_.isEmpty(filterChips) ? (
                          filterChips.map((obj) => {
                            var contestToInclude = inflencerDetails?.infContests
                              ? details?.contests?.filter((item) =>
                                  inflencerDetails?.infContests?.includes(
                                    item.contestId
                                  )
                                )
                              : details?.contests;
                            var contestArray = filterContestForListView(
                              obj?.id,
                              contestToInclude
                            );
                            if (!_.isEmpty(contestArray)) {
                              return (
                                <>
                                  <div className="z-[1] relative px-[20px] first:mt-[0] mt-[25px] flex items-center justify-between">
                                    <p className="text-largeInter">
                                      {obj?.displayText}
                                    </p>
                                    {contestArray?.some((contest) =>
                                      contest?.contestType?.startsWith("QUIZ")
                                    ) &&
                                      currentUser && (
                                        <button
                                          className="bg-white text-black px-[16px] py-[8px] text-small-bold rounded-[50px] flex items-center gap-[5px]"
                                          onClick={() => setShowProgress(true)}
                                        >
                                          <img
                                            src={progressStar}
                                            className="w-[20px] h-[20px]"
                                          />
                                          Show Progress
                                        </button>
                                      )}
                                  </div>
                                  <ContestCardCarousel
                                    contestArray={contestArray}
                                  />
                                </>
                              );
                            }
                          })
                        ) : (
                          <>
                            <div className="z-[1] relative px-[20px] flex items-center justify-between">
                              <div className="flex gap-[7px] items-center ">
                                <img
                                  src={photoContestIcon}
                                  className="w-[24px] h-[24px]"
                                />
                                <p className="text-large-medium  ">
                                  Photo Contests
                                </p>
                              </div>
                              {filteredImageArray?.some((contest) =>
                                contest?.contestType?.startsWith("QUIZ")
                              ) &&
                                currentUser && (
                                  <button
                                    className="bg-white text-black px-[16px] py-[8px] text-small-bold rounded-[50px] flex items-center gap-[5px]"
                                    onClick={() => setShowProgress(true)}
                                  >
                                    <img
                                      src={progressStar}
                                      className="w-[20px] h-[20px]"
                                    />
                                    Show Progress
                                  </button>
                                )}
                            </div>
                            <ContestCardCarousel
                              contestArray={filteredImageArray}
                            />
                            <div className="z-[1] relative px-[20px] flex items-center justify-between  mt-[45px]">
                              <div className="flex gap-[7px] items-center">
                                <img
                                  src={videoContestIcon}
                                  className="w-[24px] h-[24px]"
                                />
                                <p className="text-large-medium  ">
                                  Video Contests
                                </p>
                              </div>
                              {filteredVideoArray?.some((contest) =>
                                contest?.contestType?.startsWith("QUIZ")
                              ) &&
                                currentUser && (
                                  <button
                                    className="bg-white text-black px-[16px] py-[8px] text-small-bold rounded-[50px] flex items-center gap-[5px]"
                                    onClick={() => setShowProgress(true)}
                                  >
                                    <img
                                      src={progressStar}
                                      className="w-[20px] h-[20px]"
                                    />
                                    Show Progress
                                  </button>
                                )}
                            </div>
                            <ContestCardCarousel
                              contestArray={filteredVideoArray}
                            />
                          </>
                        )}
                      </div>

                      <div className="px-[20px] relative z-1">
                        <div className="seperator" />
                      </div>
                      {!_.isEmpty(details?.supportedBy) && (
                        <div className="px-[20px] z-[1] relative">
                          <SupportedBy
                            sponsers={details?.supportedBy}
                            setSponsorPopup={setSponsorPopup}
                            setSponsorDetails={setSponsorDetails}
                          />
                          <div className="seperator" />
                        </div>
                      )}
                      {!_.isEmpty(details?.winnerAnouncement) && (
                        <div className="px-[20px]">
                          <WinnerAnouncer
                            winnerAnouncement={details?.winnerAnouncement}
                            setWinnerAnouncementPopup={
                              setWinnerAnouncementPopup
                            }
                            setWinnerAnouncementDetails={
                              setWinnerAnouncementDetails
                            }
                          />
                          <div className="seperator" />
                        </div>
                      )}
                      {!_.isEmpty(details?.specialGuests) && (
                        <div className="px-[20px]">
                          <SpecialGuests
                            data={details?.specialGuests}
                            setGuestPopup={setGuestPopup}
                            setGuestDetails={setGuestDetails}
                          />
                          <div className="seperator" />
                        </div>
                      )}

                      {!_.isEmpty(details?.judges) && (
                        <div className="px-[20px]">
                          <Judges
                            judges={details?.judges}
                            isJudgE={isJudgE}
                            setJudgesPopup={setJudgesPopup}
                            setJudgeDetails={setJudgeDetails}
                          />
                          <div className="seperator" />
                        </div>
                      )}
                      {!_.isEmpty(details?.promoters) && (
                        <div className="px-[20px]">
                          <Promoters
                            Promoters={details?.promoters}
                            setPromoterPopup={setPromoterPopup}
                            setPromoterDetails={setPromoterDetails}
                          />
                          <div className="seperator" />
                        </div>
                      )}
                      {!_.isEmpty(details?.sponsors) && (
                        <div className="px-[20px]">
                          <Sponsers
                            sponsers={details?.sponsors}
                            setSponsorPopup={setSponsorPopup}
                            setSponsorDetails={setSponsorDetails}
                          />
                          <div className="seperator" />
                        </div>
                      )}
                      {!_.isEmpty(details?.organizer) && (
                        <div className="px-[20px]">
                          <Organizer
                            organizer={details?.organizer}
                            setOrganizerPopup={setOrganizerPopup}
                            setOrganizerDetails={setOrganizerDetails}
                          />
                          <div className="seperator" />
                        </div>
                      )}
                      <div id="couponDiv">
                        {!_.isEmpty(coupons) && (
                          <div className=" md:max-w-[100%] relative z-10  ">
                            <Coupons
                              coupons={coupons}
                              setCoupons={setCoupons}
                              handleClickCounterCampaign={
                                handleClickCounterCampaign
                              }
                            />
                          </div>
                        )}
                        <div className=" md:max-w-[100%]  ">
                          {ads?.length != 0 && (
                            <Ads
                              ads={ads}
                              promotion={false}
                              setService={setService}
                              setServiceForm={setServiceForm}
                              setDetailsPopup={setDetailsPopup}
                              handleClickCounterCampaign={
                                handleClickCounterCampaign
                              }
                            />
                          )}
                        </div>
                      </div>
                      {/* <p  className="RulesAndRegulations mt-[32px]">Contest rules</p> */}
                      {/* <p
                    onClick={() => {
                      setBlackScreen(details?.tandc);
                      setshowTHeBlackScreen(!showTHeBlackScreen);
                    }}
                    className="RulesAndRegulations mt-[12px]"
                  >
                    Terms and Conditions
                  </p> */}
                      {/* <p className="RulesAndRegulations mt-[12px]">FAQs</p> */}
                      <div className="w-[100%] h-[70px]  mt-[20px] px-[20px]">
                        {/* <div className="seperator" /> */}
                        <div className="mt-[12px] flex items-center justify-between w-[100%]">
                          <div className="flex items-center ">
                            <p className="text-small text-[#606060]">
                              To launch a contest,
                            </p>
                            <span className="flex items-center justify-center">
                              <p
                                className="text-small text-[#0F6ABE] ml-[5px] cursor-pointer"
                                onClick={profileHelpNavigate}
                              >
                                contact us
                              </p>
                              <img
                                src={Bluearrow}
                                alt=""
                                className="w-[4px] h-[8px] ml-[5px]"
                              />
                            </span>
                          </div>
                          <img
                            src={
                              buildType == "highonevent"
                                ? hoeLogo
                                : goviralLogo23
                            }
                            alt=""
                            className="w-[90px]"
                          />
                        </div>
                      </div>
                      {/* {showTHeBlackScreen === true && <AbsolutePage  />} */}
                    </div>
                  </div>
                </div>
                {/* <Footer elementId="home" /> */}
              </div>
            )}
            {showDetails && (
              <div>
                <Organiser
                  organiserDetails={details.conductedBy}
                  setShowDetails={setShowDetails}
                />
              </div>
            )}
            {winnerAnouncementPopup && (
              <DetailPopup
                setPopup={setWinnerAnouncementPopup}
                data={winnerAnouncementDetails}
              />
            )}
            {judgesPopup && (
              <DetailPopup setPopup={setJudgesPopup} data={judgeDetails} />
            )}
            {promoterPopup && (
              <PromoterPopup
                setPromoterPopup={setPromoterPopup}
                data={promoterDetails}
              />
            )}
            {guestPopup && (
              <GuestPopup setGuestPopup={setGuestPopup} data={guestDetails} />
            )}
            {sponsorPopup && (
              <SponsorPopup
                setSponsorPopup={setSponsorPopup}
                data={sponsorDetails}
              />
            )}
            {organizerPopup && (
              <OrganizerPopup
                setOrganizerPopup={setOrganizerPopup}
                data={organizerDetails}
              />
            )}
            {serviceForm && (
              <ServiceForm service={service} setServiceForm={setServiceForm} />
            )}
            {showProgress && (
              <ProgressPopup
                setPopup={setShowProgress}
                data={progressData}
                getProgress={getCampaignProgress}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default HomePage;
